import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MasterInformationService } from '../../../Services/master-information.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subscription-registration',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './subscription-registration.component.html',
  styleUrl: './subscription-registration.component.css'
})
export class SubscriptionRegistrationComponent implements OnInit {

  customerForm: FormGroup;
  customerType: string = 'individual';
  selectedUserType: any;
  selectedType: any;

  constructor(private fb: FormBuilder,
    private masterService: MasterInformationService,
    private toastr: ToastrService) {

    this.customerForm = this.fb.group({
      userType: ['1', Validators.required], 
      customerName: ['', Validators.required],
      address: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      emailAddress: ['', [Validators.required, Validators.email]],
      bankName: ['', Validators.required],
      ibanNumber: ['', [Validators.required]],
      crNumber: [''], 
      vatNumber: [''] 
    });
  }

  ngOnInit(): void {

  }

  onCustomerTypeChange(type: string) {
    this.selectedType = type;
    this.customerForm.patchValue({ userType: type });

    if (type === '1') { 
      this.customerForm.get('ibanNumber')?.clearValidators();
      this.customerForm.get('crNumber')?.clearValidators();
      this.customerForm.get('vatNumber')?.clearValidators();
    } else { 
      this.customerForm.get('ibanNumber')?.setValidators([Validators.required]);
      this.customerForm.get('crNumber')?.setValidators([Validators.required]);
      this.customerForm.get('vatNumber')?.setValidators([Validators.required]);
    }

    // Update form validity
    this.customerForm.get('ibanNumber')?.updateValueAndValidity();
    this.customerForm.get('crNumber')?.updateValueAndValidity();
    this.customerForm.get('vatNumber')?.updateValueAndValidity();
  }


  onSubmit() {
    if (this.customerForm.invalid) {
      this.customerForm.markAllAsTouched();
      return;
    }

    const formData = this.customerForm.value;

    console.log(formData)

    // Assuming you get the file from an <input type="file">
    const crFile = (document.getElementById('crFile') as HTMLInputElement)?.files?.[0];
    const vatFile = (document.getElementById('vatFile') as HTMLInputElement)?.files?.[0];
    const bankFile = (document.getElementById('bankFile') as HTMLInputElement)?.files?.[0];

    this.masterService.registerCustomer(formData, crFile, vatFile, bankFile).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          this.toastr.success(
            'Successfully Registered',
            'Success',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        }
        this.customerForm.reset();
      }
    })
  }


}
